import { isPlainObject, sortBy } from "lodash";

export const deepSortArrays = (value: object): object => {
	if(Array.isArray(value)) {
		const sorted = value.map((element) => deepSortArrays(element));
		return sortBy(sorted, (val) =>
			typeof val === "number" || typeof val === "string" ? val : String(val)
		);
	}
	
	if(isPlainObject(value)) {
		return Object.fromEntries(
			Object.entries(value).map(([key, val]) => [key, deepSortArrays(val)])
		);
	}
	
	return value;
};
